import { unByKey as olObservableUnByKey } from 'ol/Observable.js';
export default class VectorLayerCounterpart {
    olListenKeys = [];
    context;
    rootCollection_;
    /**
    * Result of the conversion of an OpenLayers layer to Cesium.
    */
    constructor(layerProjection, scene) {
        const billboards = new Cesium.BillboardCollection({ scene });
        const primitives = new Cesium.PrimitiveCollection();
        this.rootCollection_ = new Cesium.PrimitiveCollection();
        this.context = {
            projection: layerProjection,
            billboards,
            featureToCesiumMap: {},
            primitives
        };
        this.rootCollection_.add(billboards);
        this.rootCollection_.add(primitives);
    }
    /**
    * Unlisten.
    */
    destroy() {
        this.olListenKeys.forEach(olObservableUnByKey);
        this.olListenKeys.length = 0;
    }
    getRootPrimitive() {
        return this.rootCollection_;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmVjdG9yTGF5ZXJDb3VudGVycGFydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9vbGNzL2NvcmUvVmVjdG9yTGF5ZXJDb3VudGVycGFydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUMsT0FBTyxJQUFJLG1CQUFtQixFQUFDLE1BQU0sa0JBQWtCLENBQUM7QUFpQmhFLE1BQU0sQ0FBQyxPQUFPLE9BQU8sc0JBQXNCO0lBQ3pDLFlBQVksR0FBZ0IsRUFBRSxDQUFDO0lBQy9CLE9BQU8sQ0FBMkI7SUFDMUIsZUFBZSxDQUFzQjtJQUM3Qzs7TUFFRTtJQUNGLFlBQVksZUFBb0MsRUFBRSxLQUFZO1FBQzVELE1BQU0sVUFBVSxHQUFHLElBQUksTUFBTSxDQUFDLG1CQUFtQixDQUFDLEVBQUMsS0FBSyxFQUFDLENBQUMsQ0FBQztRQUMzRCxNQUFNLFVBQVUsR0FBRyxJQUFJLE1BQU0sQ0FBQyxtQkFBbUIsRUFBRSxDQUFDO1FBQ3BELElBQUksQ0FBQyxlQUFlLEdBQUcsSUFBSSxNQUFNLENBQUMsbUJBQW1CLEVBQUUsQ0FBQztRQUN4RCxJQUFJLENBQUMsT0FBTyxHQUFHO1lBQ2IsVUFBVSxFQUFFLGVBQWU7WUFDM0IsVUFBVTtZQUNWLGtCQUFrQixFQUFFLEVBQUU7WUFDdEIsVUFBVTtTQUNYLENBQUM7UUFFRixJQUFJLENBQUMsZUFBZSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUNyQyxJQUFJLENBQUMsZUFBZSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBRUQ7O01BRUU7SUFDRixPQUFPO1FBQ0wsSUFBSSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsbUJBQW1CLENBQUMsQ0FBQztRQUMvQyxJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7SUFDL0IsQ0FBQztJQUVELGdCQUFnQjtRQUNkLE9BQU8sSUFBSSxDQUFDLGVBQWUsQ0FBQztJQUM5QixDQUFDO0NBQ0YifQ==